// Per-browser memory for the "rotate your device" coach mark. Mirrors the
// favorites approach (localStorage, not the user record) so the hint follows
// the device it was shown on.
//
// Stop rules, in order: the user proved they know the feature (used), they
// closed the hint twice on purpose (dismissed), or we already spent the
// three-appearance budget on someone who never engaged.

const STORAGE_KEY = 'lbv2RotateHint'
const MAX_APPEARANCES = 3
const MAX_DISMISSALS = 2

const EMPTY_STATE = {shown: 0, dismissed: 0, used: false}

export const loadRotateHintState = () => {
  try {
    if (typeof window === 'undefined') {
      return {...EMPTY_STATE}
    }

    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? {...EMPTY_STATE, ...JSON.parse(raw)} : {...EMPTY_STATE}
  } catch {
    return {...EMPTY_STATE}
  }
}

// Returns the merged state so callers can keep deciding without a second read.
const saveRotateHintState = (changes) => {
  const newState = {...loadRotateHintState(), ...changes}

  try {
    if (typeof window !== 'undefined') {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(newState))
    }
  } catch { /* private browsing, blocked storage, quota */
  }

  return newState
}

export const shouldShowRotateHint = () => {
  const {shown, dismissed, used} = loadRotateHintState()
  return !used && dismissed < MAX_DISMISSALS && shown < MAX_APPEARANCES
}

export const recordRotateHintShown = () =>
  saveRotateHintState({shown: loadRotateHintState().shown + 1})

export const recordRotateHintDismissed = () =>
  saveRotateHintState({dismissed: loadRotateHintState().dismissed + 1})

// Called when the user rotates to landscape or taps the rotate button: proof
// they found the feature, so the hint retires for good.
export const recordRotateHintUsed = () => saveRotateHintState({used: true})
